import React from "react";
import { FaSearch, FaTimesCircle } from "react-icons/fa";

const SearchBar = ({
  placeholder = "Search...",
  value,
  onChange,
  label = "Search Records",
}) => (
  <section className="admin-search-block">
    <label className="admin-search-label">{label}</label>
    <div className="admin-search-input-wrap">
      <FaSearch className="admin-search-icon" aria-hidden="true" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="admin-search-input"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className="admin-search-clear"
        >
          <FaTimesCircle />
          <span>Clear</span>
        </button>
      ) : null}
    </div>
  </section>
);

export default SearchBar;
